import { Component, Input, OnInit } from '@angular/core';
import { UIRouter }                                      from '@uirouter/core';
import { TranslateService }                              from '@ngx-translate/core';

import { ApiService }      from '../../app-lite/api/api.service';
import { CustomerModel }  from '../../app-lite/customers/models/customer';
import { Table }           from '../../app-lite/table/types/table';
import { TableColumn }     from '../../app-lite/table/types/table-column';
import { TableRowEvent }   from '../../app-lite/table/types/table-row-event';
import { TableService }    from '../../app-lite/table/table.service';

import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

@Component({
  selector   : 'customer-events',
  template: require('./customer.events.html')
})
export class CustomerEventsComponent implements OnInit {
  @Input() customer: CustomerModel;
  @Input() events: any[];

  columns: TableColumn[];
  showCustomerEvents: boolean;
  tableCacheKey: string;
  tableSettings: Table;

  constructor (
    private apiService: ApiService,
    private tableService: TableService,
    private router: UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.showCustomerEvents = !!this.events.length;
    this.tableCacheKey      = 'customerEvents';

    this.columns = [
      {
        classes: 'all-caps',
        field  : 'event_number',
        header : {
          text: this.translateService.instant('JS_SPACE.COLUMNS.BOOKING_NUMBER')
        } },
      {
        field : 'event_date',
        header: {
          text: this.translateService.instant('BOOKING_SPACE.BOOKING_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'event_status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'total',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => this.viewEvent(event)
            }
          },
          enabled: !this.customer.archived,
          factory: EditComponent },
        sortable: false }
    ];

    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_BOOKINGS_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 5,
        pageSizes : [ 5, 10, 25, 50 ],
        queryCount: () => this.apiService.get('/customers/event_count/' + this.customer.id)
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'desc',
        field    : 'event_date'
      })
    };
  }

  getEvents ( params ): Promise<any> {
    return this.apiService.get('/customers/event_list', [
      this.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then((events) => {
      this.events = events;

      return events;
    });
  }

  onRowDoubleClick ( event: TableRowEvent ): void {
    if ( !this.customer.archived ) {
      this.router.stateService.go('app.event', {
        customer_id: this.customer.id,
        id         : event.row.id,
        vehicle_id : event.row.vehicle_id
      });
    }
  }

  viewEvent ( event: any ): void {
    this.router.stateService.go('app.event', {
      customer_id: this.customer.id,
      id         : event.id,
      vehicle_id : event.vehicle_id
    });
  }
}
